import { MatButtonLoaderStandaloneDirective } from '@abovo/shared-angular-utils';
import { CustomCardHeaderButtonAction } from '@abovo/shared-models';
import { CardHeaderComponent } from '@abovo/shared-ui-components';
import { CategoryGroupKey } from '@abovo/shared-utils';
import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimaryKpiInput, SecondaryKpiEntry, SecondaryKpiOrder, SecondaryKpisComponent } from '../../components/secondary-kpis/secondary-kpis.component';

export type KpiData = {
   kpis: SecondaryKpiEntry[];
   order?: SecondaryKpiOrder;
   readonly?: boolean;
   primaryKpi?: PrimaryKpiInput;
   currentDiscipline?: CategoryGroupKey;

   /** When true, hide the order details header and the result section with value inputs (used when values are edited elsewhere) */
   selectionOnly?: boolean;
};

@Component({
   selector: 'webvis-feature-secondary-kpi-dialog',
   templateUrl: './secondary-kpi-dialog.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
   imports: [MatDialogModule, MatButtonModule, CardHeaderComponent, MatButtonLoaderStandaloneDirective, SecondaryKpisComponent, TranslatePipe],
})
export class SecondaryKpiDialogComponent {
   private dialogRef = inject(MatDialogRef<SecondaryKpiDialogComponent>);
   data = inject<KpiData>(MAT_DIALOG_DATA, { optional: true }) || { kpis: [] };

   selectedKpisList = output<Array<SecondaryKpiEntry>>();

   saving = signal(false);
   actions: CustomCardHeaderButtonAction[] = [
      {
         icon: ['far', 'times'],
         fn: () => this.dialogRef.close(),
      },
   ];

   saveKpi(): void {
      this.saving.set(true);
      const selected = this.data.kpis.filter((kpi) => kpi.checked);
      this.selectedKpisList.emit(selected);
   }
}
